import { render } from "./InfoContactPage.vue?vue&type=template&id=52d8e52a"
import script from "./InfoContactPage.vue?vue&type=script&lang=js"
export * from "./InfoContactPage.vue?vue&type=script&lang=js"
script.render = render

export default script